<template>
    <div>
        <v-layout>
            <v-flex>
                <div id="reportList" v-if="display=='report'">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="margin: auto">
                            <v-btn dark class="yoprimary" @click="addReport" v-if="$store.state.auth.user.role==4">{{$t("lang.common.addReport")}}</v-btn>
                            <div id="divStudents">
                                <v-data-table :headers="reportHeaders" :items="reports" class="elevation-1 gru-table"
                                              hide-actions>
                                    <template v-slot:headers="props">
                                        <tr class="header">
                                            <td rowspan="1"
                                                v-if="header.text == 'Loại báo cáo' || header.text == 'Tên học sinh' "
                                                v-for="header in reportHeaders"
                                                :width="header.width"
                                                :key="header.text"
                                                align="left"
                                            >
                                                {{ $t(header.text) }}
                                            </td>
                                            <td rowspan="2" v-else
                                                :width="header.width"
                                                :key="header.text"
                                                :align="header.align"
                                            >
                                                {{ $t(header.text) }}
                                            </td>
                                        </tr>
                                        <tr class="grey lighten-3 no-print filter">
                                            <td class="text-xs-left gru-filter">
                                                <div class="border-and-box">
                                                    <v-select single-line
                                                              hide-details
                                                              flat
                                                              small
                                                              v-model="search.reportType"
                                                              name="reportType"
                                                              key="reportType"
                                                              data-vv-as="Loại báo cáo"
                                                              :items="lstReportType"
                                                              item-text="categoryName"
                                                              item-value="categoryId"
                                                              @change="getReportList"

                                                    />
                                                </div>
                                            </td>
                                            <td class="text-xs-left gru-filter" v-if="$store.state.auth.user.role!=2">
                                                <div class="border-and-box">
                                                    <v-text-field single-line
                                                                  hide-details
                                                                  flat
                                                                  small
                                                                  v-model="search.userName"
                                                                  @change="getReportList"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.index +1 }}</td>
                                        <td class="text-xs-left">{{getReportType( props.item.reportType )}}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{props.item.userName}}</td>
                                        <td class="text-xs-left">{{ props.item.reportName }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ props.item.reportDate | formatDateTime }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ getReportStatus(props.item.status)}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-btn @click="viewReport(props.item)" class="mx-0" icon>
                                                <v-icon class="primaryColor">visibility</v-icon>
                                            </v-btn>
                                            <v-btn @click="updateReport(props.item)" class="mx-0" icon v-if="$store.state.auth.user.role==4">
                                                <v-icon color="pink">edit</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
                <div id="memberList" v-else-if="display=='list'" class="yocontent">
                    <v-layout>
                        <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px">
                            <v-select label="Học sinh"
                                      single-line
                                      hide-details
                                      flat
                                      small
                                      v-model="workingReport.userId"
                                      v-validate="'required'"
                                      name="userId"
                                      key="userId"
                                      data-vv-as="Học sinh"
                                      :items="lstStudents"
                                      item-text="fullName"
                                      item-value="userId"
                                      @change="changeReportData"
                            />
                        </v-flex>
                        <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px">
                            <v-select label="Loại báo cáo"
                                      single-line
                                      hide-details
                                      flat
                                      small
                                      v-model="workingReport.reportType"
                                      v-validate="'required'"
                                      name="createReportType"
                                      key="createReportType"
                                      data-vv-as="Loại báo cáo"
                                      :items="lstReportType"
                                      item-text="categoryName"
                                      item-value="categoryId"
                                      @change="changeReportData"
                            />
                        </v-flex>
                        <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px">
                            <v-select label="Báo cáo" v-if="workingReport.reportType == 4"
                                      single-line
                                      hide-details
                                      flat
                                      small
                                      v-model="workingReport.time"
                                      v-validate="'required'"
                                      name="reportName"
                                      key="reportName"
                                      data-vv-as="Báo cáo"
                                      :items="lstMonths"
                                      item-text="reportName"
                                      item-value="time"
                                      @change="changeReportData"
                            />
                            <v-select label="Báo cáo" v-else-if="workingReport.reportType == 5"
                                      single-line
                                      hide-details
                                      flat
                                      small
                                      v-model="workingReport.time"
                                      v-validate="'required'"
                                      name="reportName"
                                      key="reportName"
                                      data-vv-as="Báo cáo"
                                      :items="lstTerms"
                                      item-text="reportName"
                                      item-value="time"
                                      @change="changeReportData"
                            />

                        </v-flex>
                        <!-- v-flex sx2 sm2 md2 lg2 xl2 style="line-height: 4">
                            <v-btn dark class="yoprimary">Tạo báo cáo</v-btn>
                        </v-flex -->
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <div style="text-align: center;font-weight: bold">BẢNG ĐÁNH GIÁ KẾT QUẢ HỌC TẬP CỦA HỌC SINH
                            </div>
                            <div style="text-align: center">{{workingReport.reportName}}</div>
                            <div><label class="label">Học và tên:</label> {{workingReport.userName}}</div>
                            <div v-if="reportMeta.class != null"><label class="label">Lớp:</label>
                                {{reportMeta.class.className}}
                            </div>
                            <div><label class="label">Giáo viên:</label> {{reportMeta.teacher}}</div>
                            <div><label class="label">Nguyện vọng học tập:</label> {{reportMeta.studyTarget}}</div>
                            <div><label class="label">Mục tiêu điểm số:</label> {{reportMeta.markTarget}}</div>
                            <div v-if="workingReport.reportType == 4">
                                <div><label class="label">1. Danh sách bài tập trong tháng</label></div>
                                <v-data-table :headers="detailReportHeaders" class="elevation-1"
                                              :items="reportData" hide-actions locale="vi">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-right">{{ props.index+1}}</td>
                                        <td class="text-xs-left">{{ props.item["exerciseName"] }}</td>
                                        <td class="text-xs-right">{{ props.item["mark"] }}</td>
                                        <td class="text-xs-right">{{ props.item["teacherComment"] }}</td>
                                        <td class="text-xs-right">{{ props.item["teacherCommentImprove"] }}</td>
                                    </template>
                                </v-data-table>
                                <div><label class="label">2. Tổng kết tháng</label></div>
                                <table class="lstTable">
                                    <tr>
                                        <th>Tỉ lệ hoàn thành bài tập</th>
                                        <th>Điểm trung bình tháng</th>
                                        <th>Điểm tháng trước</th>
                                        <th>Chênh lệch điểm so với tháng trước</th>
                                        <th>Điểm mục tiêu</th>
                                        <th>Đánh giá điểm so với mục tiêu</th>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right">{{reportMeta.completedPercent}}</td>
                                        <td style="text-align: right">{{reportMeta.markAverage}}</td>
                                        <td style="text-align: right">{{reportMeta.previousMark}}</td>
                                        <td style="text-align: right">{{reportMeta.difference}}</td>
                                        <td style="text-align: right">{{reportMeta.markTarget}}</td>
                                        <td>{{reportMeta.evaluated}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div v-else-if="workingReport.reportType == 5">
                                <div><label class="label">1. Tổng kết điểm trung bình trong học kỳ</label></div>
                                <table class="lstTable">
                                    <tr>
                                        <th>{{reportMeta.month0}}</th>
                                        <th>{{reportMeta.month1}}</th>
                                        <th>{{reportMeta.month2}}</th>
                                        <th>{{reportMeta.month3}}</th>
                                        <th>{{reportMeta.month4}}</th>
                                        <th>Điểm trung bình</th>
                                        <th>Đánh giá điểm so với mục tiêu</th>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right">{{reportMeta.month0Mark}}</td>
                                        <td style="text-align: right">{{reportMeta.month1Mark}}</td>
                                        <td style="text-align: right">{{reportMeta.month2Mark}}</td>
                                        <td style="text-align: right">{{reportMeta.month3Mark}}</td>
                                        <td style="text-align: right">{{reportMeta.month4Mark}}</td>
                                        <td style="text-align: right">{{reportMeta.markAverage}}</td>
                                        <td>{{reportMeta.evaluated}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <datalist id="evaluateConsciosnessRank">
                                    <option value="Rất tốt"/>
                                    <option value="Tốt"/>
                                    <option value="Khá"/>
                                    <option value="Kém"/>
                                </datalist>
                                <datalist id="evaluateStudyRank">
                                    <option value="Xuất sắc"/>
                                    <option value="Giỏi"/>
                                    <option value="Khá"/>
                                    <option value="Trung bình"/>
                                    <option value="Kém"/>
                                </datalist>
                                <div><label class="label">{{getIndexOfDetailEvaluate}}. Đánh giá chi tiết cho học sinh</label></div>
                                <table class="lstTable" style="margin-top: 10px">
                                    <tr><td colspan="4" class="titleRow">Ý thức học tập</td></tr>
                                    <tr>
                                        <th>Chuyên cần</th>
                                        <th>Ý thức trong giờ học</th>
                                        <th>Bài tập về nhà</th>
                                        <th>Xếp loại</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-textarea  hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                          v-model="reportInfo.consciousnessDiligence"
                                                         :readonly="!editReport"
                                            />
                                        </td>
                                        <td>
                                            <v-textarea   hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                          v-model="reportInfo.consciousnessInclass"
                                                          :readonly="!editReport"
                                            />

                                        </td>
                                        <td>
                                            <v-textarea   hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                          :readonly="!editReport"
                                                          v-model="reportInfo.consciousnessHomework"
                                            />

                                        </td>
                                        <td>
                                            <v-text-field single-line
                                                          hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                          :readonly="!editReport"
                                                          v-model="reportInfo.consciousnessRank"
                                                          list="evaluateConsciosnessRank"
                                            />
                                        </td>
                                    </tr>
                                </table>

                                <table class="lstTable" style="margin-top: 10px">
                                    <tr><td colspan="2" class="titleRow">Học tập</td></tr>
                                    <tr>
                                        <th>Điểm mạnh - điểm yếu và cách khắc phục</th>
                                        <th>Xếp loại</th>
                                    </tr>
                                    <tr>
                                        <td class="text-xs-left gru-filter">
                                            <v-textarea hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                        :readonly="!editReport"
                                                          v-model="reportInfo.studyStrongWeakness"
                                            />

                                        </td>
                                        <td class="text-xs-left gru-filter">
                                            <v-text-field hide-details
                                                          flat
                                                          small
                                                          :readonly="!editReport"
                                                          v-model="reportInfo.studyRank"
                                                          list="evaluateStudyRank"
                                            />

                                        </td>
                                    </tr>
                                </table>

                                <table class="lstTable" style="margin-top: 10px">
                                    <tr><td class="titleRow">Nhận xét chung và khuyến nghị</td></tr>
                                    <tr>
                                        <td>
                                            <v-textarea   hide-details
                                                          flat
                                                          small
                                                          label="GV nhập nhận xét"
                                                          :readonly="!editReport"
                                                          v-model="reportInfo.teacherComment"
                                            />

                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </v-flex>
                    </v-layout>
                    <div style="text-align: right">
                        <v-btn color="primary" @click="onExportReport">
                            {{$t('lang.common.exportReport') }}
                        </v-btn>
                        <v-btn class="blue" dark @click="onSend" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.class.send')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="editReport = true" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.common.edit')}}
                        </v-btn>
                        <v-btn @click="saveReport()" v-if="editReport && $store.state.auth.user.role==4"
                               class="yoprimary" dark>
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn @click="closeDetail()" color="red" dark>
                            {{$t('lang.common.back')}}
                        </v-btn>
                    </div>
                </div>
                <send-to-member :class-id="classId" :user-id="workingReport.userId" @send="onChangeReceiver" ref="sendDialog" :selectable="false"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import SendToMember from "../sendToMember";

    export default {
        name: "student-report-page",
        components: {SendToMember},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            display: "report",
            editReport: false,
            search: {
                'reportType': null,
                'userName': null
            },
            year: null,
            term: null,
            lstReportType: [
                {'categoryName': 'Tất cả', 'categoryId': null},
                {'categoryName': 'Báo cáo tháng', 'categoryId': 4},
                {'categoryName': 'Báo cáo kỳ', 'categoryId': 5},
            ],
            lstStudents: [],
            lstMonths: [],
            lstTerms: [],
            studentHeaders: [
                {
                    text: "Sinh viên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {text: "Báo cáo chi tiết", value: "name", align: "center", sortable: false}
            ],
            students: [],
            reportData: [],
            reportMeta: {},
            reportInfo: {},
            workingReport: {},
            reports: [],
            exerciseId: null,
            exerciseType: null,
            averateMark: null,
        }),

        computed: {
            detailReportHeaders: function () {
                if (this.editReport) {
                    return [
                        {
                            text: "STT",
                            align: "right",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Tên bài tập",
                            align: "left",
                            sortable: false,
                            value: "exerciseName"
                        },
                        {
                            text: "Điểm",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "Nhận xét bài tập",
                            align: "right",
                            sortable: false,
                            value: "teacherComment"
                        },
                        {
                            text: "Nhận xét thái độ học tập",
                            align: "right",
                            sortable: false,
                            value: "teacherCommentImprove"
                        }
                    ]
                } else {
                    return [
                        {
                            text: "STT",
                            align: "right",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Tên bài tập",
                            align: "left",
                            sortable: false,
                            value: "exerciseName"
                        },
                        {
                            text: "Điểm",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "Nhận xét bài tập",
                            align: "right",
                            sortable: false,
                            value: "teacherComment"
                        },
                        {
                            text: "Nhận xét thái độ học tập",
                            align: "right",
                            sortable: false,
                            value: "teacherCommentImprove"
                        }
                    ]
                }
            },

            getIndexOfDetailEvaluate: function(){
                if(this.workingReport.reportType == 4){
                    return "3";
                } else {
                    return  "2";
                }
            },

            reportHeaders(){
                if(this.$store.state.auth.user.role==2){
                    return [
                        {
                            text: "STT",
                            align: "left",
                            width: '5%',
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            width: '15%',
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            width: '15%',
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            width: '10%',
                            sortable: false,
                            value: "status"
                        }
                    ];
                } else {
                    return [
                        {
                            text: "STT",
                            align: "left",
                            width: '5%',
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            width: '15%',
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên học sinh",
                            align: "left",
                            width: '20%',
                            sortable: false,
                            value: "userName"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            width: '15%',
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Thời gian cập nhật",
                            align: "left",
                            width: '10%',
                            sortable: false,
                            value: "reportDate"
                        },
                        {
                            text: "Trạng thái",
                            align: "left",
                            width: '10%',
                            sortable: false,
                            value: "status"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            width: '10%',
                            sortable: false,
                            value: "status"
                        }
                    ];
                }
            }

        },

        watch: {
            classId: function (data) {
                this.getReportList();
            },
            month: function (data) {
                console.log(data);
            }
        },

        created() {
            this.search.classId = this.classId;
            this.workingReport.classId = this.classId;
        },

        methods: {
            init(){
                this.getReportList();
                this.getStudentOfClass();
                this.getMonthReportLis();
                this.getTermReportList();
            },

            getReportType: function (type) {
                let typeName = "";
                switch (type) {
                    case 0:
                        typeName = "Báo cáo sau bài tập";
                        break;
                    case 1:
                        typeName = "Báo cáo cá nhân";
                        break;
                    case 2:
                        typeName = "Báo cáo tháng";
                        break;
                    case 3:
                        typeName = "Báo cáo kỳ";
                        break;
                    case 4:
                        typeName = "Báo cáo tháng";
                        break;
                    case 5:
                        typeName = "Báo cáo kỳ";
                        break;
                }
                return typeName;
            },

            getReportStatus: function (status) {
                let name = "";
                switch (status) {
                    case 0:
                        name = "Chưa cập nhật";
                        break;
                    case 1:
                        name = "Đã cập nhật";
                        break;
                    case 2:
                        name = "Đã gửi";
                        break;
                }
                return name;

            },

            getReportList: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listStudentReport", this.search
                    )
                    .then(
                        data => {
                            this.reports = data;
                        },
                        error => {
                        }
                    )

            },

            getStudentOfClass: function () {
                axios
                    .post(process.env.VUE_APP_API_URL + "/classmember/myStudents?classId=" + this.classId)
                    .then(
                        data => {
                            this.lstStudents = data;
                        },
                        error => {
                        }
                    );

            },

            getMonthReportLis: function () {
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listMonthlyReport?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.lstMonths = data;
                            this.lstMonths.sort(
                                (b,a)=>{
                                    if(a.year == b.year){
                                        return a.month - b.month;
                                    } else {
                                        return a.year- b.year;
                                    }
                                }
                            )
                            for (let i = 0; i < this.lstMonths.length; i++) {
                                this.lstMonths[i].time = this.lstMonths[i].year + "_" + this.lstMonths[i].month;
                            }
                            console.log(this.lstMonths);
                        },
                        error => {
                        }
                    )

            },

            getTermReportList: function () {
                axios
                    .post(process.env.VUE_APP_API_URL + "/report/listTermReport?classId=" + this.classId)
                    .then(
                        data => {
                            this.lstTerms = data;
                            this.lstTerms.sort(
                                (b,a)=>{
                                    if(a.year == b.year){
                                        return a.month - b.month;
                                    } else {
                                        return a.year- b.year;
                                    }
                                }
                            )
                            for (let i = 0; i < this.lstTerms.length; i++) {
                                this.lstTerms[i].time = this.lstTerms[i].year + "_" + this.lstTerms[i].month;
                            }
                        },
                        error => {
                        }
                    );

            },

            viewReport: function (report) {
                this.year = report.year;
                this.month = report.month;
                this.term = report.month;
                this.editReport = false;
                this.display = "list";
                this.workingReport = report;
                this.workingReport.time = report.year+"_"+ report.month;
                this.getMarkReport();
            },

            addReport: function () {
                this.updateReport(null);
            },

            updateReport: function (report) {
                this.editReport = true;
                this.display = "list";
                //this.workingReport = report;
                if (report != null) {
                    this.year = report.year;
                    this.term = report.month;
                    this.month = report.month;
                    this.workingReport = report;
                    this.workingReport.time = report.year+"_"+ report.month;
                    this.getMarkReport();
                } else {
                    this.workingReport = {
                        'classId':this.classId
                    };
                }
            },

            getMarkReport: function () {
                if(this.workingReport.userId == null || this.workingReport.userId == undefined){
                    return;
                }
                if(this.workingReport.reportType == null || this.workingReport.reportType == undefined){
                    return;
                }
                if(this.workingReport.year == null || this.workingReport.year == undefined){
                    return;
                }
                axios.post(process.env.VUE_APP_API_URL + "/report/getStudentReport?classId=" + this.classId + "&userId=" + this.workingReport.userId + "&reportType=" + this.workingReport.reportType + "&year=" + this.workingReport.year + "&month=" + this.workingReport.month)
                    .then(
                        data => {
                            this.reportMeta = data;
                            this.reportData = data.lstData;
                            this.reportInfo = data.report;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/report/downloadStudentReport?classId=" + this.classId+"&userId="+ this.workingReport.userId+"&reportType="+this.workingReport.reportType+ "&year=" + this.workingReport.year + "&month=" + this.workingReport.year;
                window.location.href = url;
            },

            saveReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/saveStudentReportData", this.reportInfo)
                    .then(
                        data => {
                            if (data.success) {
                                axios.post(process.env.VUE_APP_API_URL + "/report/saveReport?", this.workingReport).then(
                                    saveResult => {
                                        if (saveResult.success) {
                                            message.success(this.$t('lang.common.save_success'));
                                            this.workingReport = saveResult.ref;
                                            this.workingReport.time = this.workingReport.year + "_" + this.workingReport.month;
                                            this.editReport = false;
                                            this.getMarkReport();
                                        }
                                    },

                                    saveError => {
                                        message.error(saveError);

                                    }
                                );

                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

            },

            closeDetail: function () {
                this.display = "report";
                this.getReportList();
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendStudentEmailReport?classId=" + this.classId +"&userId="+ this.workingReport.userId+"&reportType="+this.workingReport.reportType+ "&year=" + this.workingReport.year + "&month=" + this.workingReport.year)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendSMS: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendStudentSMSReport?classId=" + this.classId+"&userId="+ this.workingReport.userId+"&reportType="+this.workingReport.reportType+ "&year=" + this.workingReport.year + "&month=" + this.workingReport.year)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi SMS thành công");
                            } else {
                                message.error("Gửi SMS không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                //debugger;
                //console.log(url);
                let state = this.classId + "_" + this.workingReport.year + "_" + this.workingReport.year + "_student_"+this.workingReport.reportType;
                url = encodeURIComponent(url);
                //console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },

            onSend: function () {
                this.$refs.sendDialog.show();
            },

            onChangeReceiver: function (receivers) {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendReport", this.workingReport).then(
                    data => {
                        if (data.success) {
                            this.onSendEmail();
                            this.onSendSMS();
                            //this.onSendZalo();
                            this.workingReport = data.ref;
                        }
                    }
                )
            },

            changeReportData: function () {
                //
                // update month and year of report
                //
                if (this.workingReport.reportType == 4) {
                    for (let i = 0; i < this.lstMonths.length; i++) {
                        if (this.lstMonths[i].time == this.workingReport.time) {
                            this.workingReport.reportName = this.lstMonths[i].reportName;
                            break;
                        }
                    }
                } else if (this.workingReport.reportType == 5) {
                    for (let i = 0; i < this.lstTerms.length; i++) {
                        if (this.lstTerms[i].time == this.workingReport.time) {
                            this.workingReport.reportName = this.lstTerms[i].reportName;
                            break;
                        }
                    }
                }
                this.workingReport.year = this.workingReport.time.split("_")[0];
                this.workingReport.month = this.workingReport.time.split("_")[1];
                //
                // update username
                //
                for (let i = 0; i < this.lstStudents.length; i++) {
                    if (this.lstStudents[i].userId == this.workingReport.userId) {
                        this.workingReport.userName = this.lstStudents[i].fullName;
                        break;
                    }
                }
                this.getMarkReport();
                console.log(this.workingReport);
            }
        }
    };
</script>